
import { IconPackage, RevLink } from '@backmarket/design-system'
import { camelizeKeys } from 'humps'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { PaymentIcons, productPaymentAdvertising } from '@payment'
import paymentInstallmentsTranslations from '@payment/modules/advertising/config/advertising.translations'

import translations from './AdvertisedPayment.translations'

export default {
  components: {
    RevLink,
    IconPackage,
    PaymentIcons,
  },
  props: {
    asLowAs: {
      type: Object,
      default: () => ({}),
    },
    paymentMethods: {
      type: Array,
      default: () => [],
    },
    price: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      countryPaymentMethods: 'countryConfig/paymentMethods',
    }),
    translations: () => translations,

    advertisedPayment() {
      const { advertised } = productPaymentAdvertising(
        isEmpty(this.paymentMethods)
          ? this.countryPaymentMethods
          : camelizeKeys(this.paymentMethods),
      )

      // TODO [CK-13] Integrate this in productPaymentAdvertising
      if (!isEmpty(advertised)) {
        advertised.cta = paymentInstallmentsTranslations.payInInstallmentsCta
      }

      return {
        price: this.asLowAs,
        details: advertised,
      }
    },

    showAdvertisedPayment() {
      return !isEmpty(this.advertisedPayment.details)
    },
  },
}
